// Theme toggle module for light/dark mode
// Lives in the custom JS section and is included globally.

(function (window, document) {
	'use strict';

	var COOKIE_NAME = 'tms_theme';
	var COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

	function readCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) {
				var raw = c.substring(nameEQ.length, c.length);
				try {
					return decodeURIComponent(raw.replace(/\+/g, ' '));
				} catch (e2) {
					return raw;
				}
			}
		}
		return null;
	}

	function writeCookie(name, value, maxAgeSeconds) {
		var cookie = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';
		if (typeof maxAgeSeconds === 'number') {
			cookie += '; max-age=' + maxAgeSeconds;
		}
		if (typeof window.location === 'object' && window.location.protocol === 'https:') {
			cookie += '; Secure';
		}
		document.cookie = cookie;
	}

	function readLocalStorageTheme() {
		try {
			return localStorage.getItem(COOKIE_NAME);
		} catch (e) {
			return null;
		}
	}

	function writeLocalStorageTheme(theme) {
		try {
			localStorage.setItem(COOKIE_NAME, theme);
		} catch (e) {
			// private mode / disabled storage — cookie path=/ still applies when set from /toptech
		}
	}

	function persistThemeToServer(theme) {
		// Use existing synajax queue helper when available.
		// Packet format aligns with synajax/procajax.inc.php command routing.
		if (typeof window.queueRequest === 'function') {
			try {
				window.queueRequest(
					'tms_theme',
					0,
					{ cmd: 'themeswitch', parm: { theme: theme } },
					'tms_theme_switch'
				);
			} catch (e) {
				// Keep UI switching resilient even if ajax queue is unavailable/fails.
			}
		}
	}

	function updateLogoForTheme(theme) {
		var logoElements = document.querySelectorAll('img.logoimage');
		if (!logoElements || logoElements.length === 0) {
			return;
		}

		for (var i = 0; i < logoElements.length; i++) {
			var img = logoElements[i];
			var src = img.getAttribute('src');
			if (!src) {
				continue;
			}

			// Only operate on product logo images and preserve any query string.
			// Examples:
			// product_logo_full_tms.png -> product_logo_full_tms_dark.png
			// product_logo_full_tms_dark.png -> product_logo_full_tms.png
			var updatedSrc = src.replace(
				/(product_logo_full_[^\/]+?)(?:_dark)?(\.[a-zA-Z0-9]+)(\?.*)?$/,
				function (_match, baseName, ext, query) {
					var q = query || '';
					if (theme === 'dark') {
						return baseName + '_dark' + ext + q;
					}
					return baseName + ext + q;
				}
			);

			if (updatedSrc !== src) {
				img.setAttribute('src', updatedSrc);
			}
		}
	}

	function preloadThemeLogos() {
		var logoElements = document.querySelectorAll('img.logoimage');
		if (!logoElements || logoElements.length === 0) {
			return;
		}

		for (var i = 0; i < logoElements.length; i++) {
			var src = logoElements[i].getAttribute('src');
			if (!src) {
				continue;
			}

			var darkSrc = src.replace(
				/(product_logo_full_[^\/]+?)(?:_dark)?(\.[a-zA-Z0-9]+)(\?.*)?$/,
				function (_match, baseName, ext, query) {
					var q = query || '';
					return baseName + '_dark' + ext + q;
				}
			);

			var lightSrc = src.replace(
				/(product_logo_full_[^\/]+?)(?:_dark)?(\.[a-zA-Z0-9]+)(\?.*)?$/,
				function (_match, baseName, ext, query) {
					var q = query || '';
					return baseName + ext + q;
				}
			);

			if (darkSrc !== src) {
				var darkImg = new Image();
				darkImg.src = darkSrc;
			}

			if (lightSrc !== src) {
				var lightImg = new Image();
				lightImg.src = lightSrc;
			}
		}
	}

	function getCurrentTheme() {
		var html = document.documentElement;
		// Prefer data-bs-theme if present
		var dataTheme = html.getAttribute('data-bs-theme');
		if (dataTheme === 'dark' || dataTheme === 'light') {
			return dataTheme;
		}
		// Fallback to presence of .dark class
		if (html.classList && html.classList.contains('dark')) {
			return 'dark';
		}
		return 'light';
	}

	function applyTheme(theme) {
		if (theme !== 'dark' && theme !== 'light') {
			theme = 'light';
		}

		var html = document.documentElement;

		// Update HTML class and data attribute for Bootstrap / CSS hooks
		if (html.classList) {
			if (theme === 'dark') {
				html.classList.add('dark');
			} else {
				html.classList.remove('dark');
			}
		}

		html.setAttribute('data-bs-theme', theme);

		// Persist choice (path=/ so site root landing page receives it; SameSite for modern browsers)
		writeCookie(COOKIE_NAME, theme, COOKIE_MAX_AGE);
		writeLocalStorageTheme(theme);
		updateLogoForTheme(theme);
		persistThemeToServer(theme);

		// Fire a lightweight event so any listeners can react (e.g., components watching theme changes)
		try {
			var evt;
			if (typeof Event === 'function') {
				evt = new Event('tms-theme-changed');
			} else {
				evt = document.createEvent('Event');
				evt.initEvent('tms-theme-changed', true, true);
			}
			window.dispatchEvent(evt);
		} catch (e) {
			// Swallow any event errors; theme has still been applied and cookie set.
		}
	}

	function toggleTheme() {
		var current = getCurrentTheme();
		var next = current === 'dark' ? 'light' : 'dark';
		applyTheme(next);
	}

	function initFromCookie() {
		// Warm logo variants on initial load so toggles feel immediate.
		preloadThemeLogos();

		var cookieTheme = readCookie(COOKIE_NAME);
		var lsTheme = readLocalStorageTheme();
		var resolved = null;
		if (cookieTheme === 'dark' || cookieTheme === 'light') {
			resolved = cookieTheme;
		} else if (lsTheme === 'dark' || lsTheme === 'light') {
			// Cookie missing at this URL (e.g. old Path=/toptech only) — still apply from storage
			resolved = lsTheme;
		}
		if (resolved === 'dark' || resolved === 'light') {
			if (resolved !== getCurrentTheme()) {
				applyTheme(resolved);
			} else {
				// DOM already correct (e.g. from PHP); still re-issue path=/ cookie + storage for migration
				writeCookie(COOKIE_NAME, resolved, COOKIE_MAX_AGE);
				writeLocalStorageTheme(resolved);
			}
		}
	}

	// Expose a small API on window
	window.TMSTheme = {
		getCurrentTheme: getCurrentTheme,
		applyTheme: applyTheme,
		toggleTheme: toggleTheme,
		initFromCookie: initFromCookie
	};

	// Automatically sync from cookie once DOM is ready
	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		// Slight delay to ensure <html> classes from server are in place
		setTimeout(initFromCookie, 0);
	} else {
		document.addEventListener('DOMContentLoaded', function () {
			initFromCookie();
		});
	}

})(window, document);

